export default __webpack_public_path__ + "static/media/logo.88a10a43.webp";